module.exports = __webpack_public_path__ + "static/media/icon-touch.366655d7.svg";